import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import GROUPS_QUERY from '../queries/GROUPS_QUERY';
 
const useGroups = () => {
    const [ groups, setGroups ] = useState( [] );
    const { data, loading, error } = useQuery( GROUPS_QUERY );

    useEffect( () => {
        if ( loading || error || !data || !data.groups?.edges ) { return; }
        
        try {
            const result = data.groups.edges.map( i => { 
                return {
                    id: i.node?.id || '',
                    key: i.node?.id || '',
                    name: i.node?.name || '', 
                    type: i.node?.slug || '', 
                    attributes: i.node?.attributes || [], 
                }; 
            } ).sort( ( a, b ) => a.name.localeCompare( ( b ) ) );

            setGroups( result );
        } catch ( error ) {
            console.error( 'Error parsing groups', error ); 
            setGroups( [] );
        }
    }, [ loading, error ] );
  
    const getGroup = ( id ) => groups.find( i => i.id === id );
    const getGroupLabel = ( id ) => getGroup( id )?.name || 'Not found';

    return useMemo( () => {
        return {
            groups,
            groupsError: error,
            groupsLoading: loading,
            getGroup,
            getGroupLabel
        };
    }, [ groups, error, loading ] );
};

export default useGroups;
